import { render } from "./VideoErrorComponent.vue?vue&type=template&id=e0522788&scoped=true&ts=true"
import script from "./VideoErrorComponent.vue?vue&type=script&lang=ts"
export * from "./VideoErrorComponent.vue?vue&type=script&lang=ts"

import "./VideoErrorComponent.vue?vue&type=style&index=0&id=e0522788&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0522788"]])

export default __exports__